import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["applicationDeadline"]

  connect() {
    this.applicationDeadlineManuallyChanged = false
    if (this.hasApplicationDeadlineTarget) {
      this.applicationDeadlineTarget.addEventListener("input", () => {
        this.applicationDeadlineManuallyChanged = this.applicationDeadlineTarget.value !== this.applicationDeadlineTarget.dataset.autoValue
      })
    }
    this.recalculate()
  }

  recalculate() {
    const ranges = this.programDateRanges()
    const dayCount = this.dayCountFromRanges(ranges)
    const nightCount = this.nightCountFromRanges(ranges)

    this.syncApplicationDeadline(ranges)
    this.element.dataset.programDateRangesDayCount = dayCount === null ? "" : String(dayCount)
    this.element.dataset.programDateRangesNightCount = nightCount === null ? "" : String(nightCount)
    this.writeOutput("program_duration", dayCount)
    this.writeOutput("day_count", nightCount)
    this.dispatch("changed", { bubbles: true })
  }

  programDateRanges() {
    return Array.from(this.element.querySelectorAll("[data-date-range-list-target='row']")).map((row) => {
      const startInput = row.querySelector("[data-date-range-start]")
      const endInput = row.querySelector("[data-date-range-end]")

      return [this.dateFromInput(startInput), this.dateFromInput(endInput)]
    })
  }

  syncApplicationDeadline(ranges) {
    if (!this.hasApplicationDeadlineTarget) return
    if (this.applicationDeadlineManuallyChanged) return

    const startDate = ranges.map(([startDate]) => startDate).find((date) => date !== null)
    if (startDate === undefined) return

    const deadline = new Date(startDate)
    deadline.setDate(deadline.getDate() - 10)
    const autoValue = this.formatDate(deadline)

    if (this.applicationDeadlineTarget.value && this.applicationDeadlineTarget.value !== this.applicationDeadlineTarget.dataset.autoValue) return

    this.applicationDeadlineTarget.value = autoValue
    this.applicationDeadlineTarget.dataset.autoValue = autoValue
  }

  dateFromInput(element) {
    if (!element) return null
    if (element.value.trim().length === 0) return null

    const date = new Date(`${element.value}T00:00:00`)
    return Number.isNaN(date.getTime()) ? null : date
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")

    return `${year}-${month}-${day}`
  }

  writeOutput(key, value) {
    const elements = this.element.querySelectorAll(`[data-calculation-output="${key}"]`)
    const rawValue = value === null ? "" : String(value)

    elements.forEach((element) => {
      if ("value" in element) {
        element.value = rawValue
      } else {
        element.textContent = rawValue || "—"
      }
    })
  }

  dayCountFromRanges(ranges) {
    const counts = ranges.map(([startDate, endDate]) => this.dayCountFromDates(startDate, endDate)).filter((value) => value !== null)
    if (counts.length === 0) return null

    return counts.reduce((total, value) => total + value, 0)
  }

  nightCountFromRanges(ranges) {
    const counts = ranges.map(([startDate, endDate]) => this.nightCountFromDates(startDate, endDate)).filter((value) => value !== null)
    if (counts.length === 0) return null

    return counts.reduce((total, value) => total + value, 0)
  }

  dayCountFromDates(startDate, endDate) {
    if (startDate === null || endDate === null) return null
    if (endDate < startDate) return null

    const diff = Math.round((endDate - startDate) / 86400000)
    return diff + 1
  }

  nightCountFromDates(startDate, endDate) {
    const dayCount = this.dayCountFromDates(startDate, endDate)
    if (dayCount === null) return null

    return dayCount === 1 ? 1 : dayCount - 1
  }
}
